// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"2597704f","395":"06a84be1","643":"0e02bb73","734":"a484f421","828":"b15d7cbe"}[chunkId] + ".chunk.js";
};